import styled, { css } from 'styled-components';
import Image from '../../../../image';
export const imageReceiptStyles = () => css `
	margin: 0;
	width: auto;
`;
export const StyledReceiptImage = styled(Image) `
	${imageReceiptStyles}
`;
